/* eslint-disable @typescript-eslint/no-unused-vars */
import BackButton from '../../components/BackButton'
import LanguageStrings from '../../i18n/locales'
import React, { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { type RootState } from '../../store'
import ConfigurationTable from './components/configTable'
import { type ConnectedProps, connect, useDispatch, useSelector } from 'react-redux'
import { createNewConfig, fetchAllConfigs } from './redux/actionCreators'
import { useAuth } from 'react-oidc-context'
import { CircularProgress, Grid } from '@mui/material'
import { Button } from '../../components/Button'
import { type AllConfigData, type ConfigState } from './redux/allConfigSlice'
import { type CreateConfigurationState } from './redux/addNewConfigSlice'
import { Modal } from '@scuf/common'

const AmiMeterCollectionDP = (props: PropsFromRedux): JSX.Element => {
  const AMIMeterCollectionStrings = LanguageStrings().AMIDataCollectionStrings.LandingPage
  const DeviceDetailsStrings = LanguageStrings().DeviceDetailsStrings
  const dispatch = useDispatch()
  const auth = useAuth()
  const navigate = useNavigate()
  const ConfigurationListStrings = LanguageStrings().AssetConfigurationStrings.ConfigurationListString

  // const numConfigurations = useSelector((state: RootState) => state.allConfigData. !== null ? state.configurationList.configurationList.total_count : 0)

  useEffect(() => {
    props.fetchAllConfigs(0, 10, auth.user?.profile.customer as string)
  }, [])

  useEffect(() => {
    props.fetchAllConfigs(0, 10, auth.user?.profile.customer as string)
  }, [props.createDatapubConfig])

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  function testPost () {
    props.createNewConfig(
      {
        description: 'This is for the demo',
        spec_version: 'Version 2.1',
        name: 'Test config2',
        public_key: 'ssh-ed25519-RYr9BVgIY2fmsnkh-4WIN2cO1szSRR-st5q0OPRhMCY',
        file_created: '2023-09-15T16:51:43.177991215Z',
        encryption_enabled_state: false,
        protocol: 'SFTP',
        sftp_host_name: '172.19.16.236',
        url: '',
        username: 'sftpuser',
        password: 'sftp1234!!',
        sftp_port: 22,
        sftp_public_key: 'AAAAB3NzaC1yc2EAAAADAQABAAABgQC6UEpKRLxEcRWjCAUYOIzu6n6ZrUVytI76I1q1cv1AahLy8nUOcr0Iwa//DsLRY4eWQGqgoFADINb2I9OtM3k5I/cAqPNeH0JbWRBGZEkqZoYpHaHZHwnmekGZddulnO+38rhxzgQySCPJKQtIddjF7uICam5FRhybGBvcjL/PbbLSnxtf9yy/sd4yqckNyB93ozmt6SSK6hE45ZNsuekM6Hd44AUWcb/Yx5Q43cszA8omGBzIcXi5SqcQ7OP2AlLgv17moNUvgOvZbCHbqZt5TIrUJtI1Ubl3tYytBhPOpR8KV/AYtK32jluqWGsk9AHkVpPi85k9O/WYP1du6dEJ62FuD79bDbZsjbTieM3hUw2E8bLkh7NCHqmcszxTDGfHIUnErPewIoDtSfTmCoY/LYf3VyJnaeJPN3P/tJc9iTKfBm6aNX+ln9P8NusOFox0PbAOL9o+qIQOPK486+UzZvP7q0osTE/9Q3kAVTfMi7P3EgAm9OXlNd3c9jlOjdM=',
        sftp_encryption_string: 'ssh-rsa',
        publisher_id: 532,
        tenant_id: 'honeywell',
        file_format: 'CMEP',
        enabled: true,
        minutes_between_publishing: 1,
        hour_of_day_to_start: 11,
        minute_of_day_to_start: 0,
        minutes_after_hour: 0,
        frequency_type: 1
      })

    return (
    <Modal buttonTypeNegative='hollow' title='Successfully created' LabelPositive='Ok' onClickPositive={() => { navigate('/datapub') }}
      onClose={() => { navigate('/datapub') }}>
      <p style={{ paddingTop: '1.2em' }}>{'Configuration_has_been_created_successfully'}</p>
    </Modal>
    )
  }

  return (
        <div>
            <div className='topUtilityBar'>
                <BackButton/>
                <span id='componentTitle'>{'DATA PUBLISHER'}</span>
                <span id='top-right-ami-utilities'>
                  <span id='top-right-btn-span'>
                    <Button id='top-right-ami-btn' className='deviceList' sx={{ margin: 0 }} width='fit-content' onClick={() => {
                      testPost()
                    }} dataTestId='create-config-btn'>{'Add Data Publisher'}</Button>
                  </span>
                  <Button id='top-right-ami-btn' className='deviceList' sx={{ margin: 5 }} width='fit-content' onClick={() => {
                    navigate('/filestatus')
                  }} dataTestId='create-config-btn'>{'View Status Files'}</Button>
                  <span id='top-right-btn-span'>

                  </span>
                </span>
            </div>
            <div>
              <div className='configurations-table-heading'>
                <h5>Data Publisher List <span className='config-list-box'>{props.allConfigData.configData?.configurations?.length} Data Publisher</span></h5>
              </div>
                <ConfigurationTable />
            </div>
            <br />
        </div>
  )
}

interface DispatchToProps {
  fetchAllConfigs: (page: number, size: number, tenantId: string) => void
  createNewConfig: (configTemplate: AllConfigData) => void
}

const mapDispatchToProps = (dispatch: any): DispatchToProps => ({
  fetchAllConfigs: (page: number, size: number, tenantId: string) => dispatch(fetchAllConfigs(page, size, tenantId)),
  createNewConfig: (configTemplate: AllConfigData) => dispatch(createNewConfig(configTemplate))
})
interface StateToProps {
  allConfigData: ConfigState
  createDatapubConfig: CreateConfigurationState
}

const mapStateToProps = (state: RootState): StateToProps => ({
  allConfigData: state.allConfigData,
  createDatapubConfig: state.createDatapubConfig
})

const connector = connect(mapStateToProps, mapDispatchToProps)
type PropsFromRedux = ConnectedProps<typeof connector>

export default connector(AmiMeterCollectionDP)
